module.exports = __webpack_public_path__ + "static/media/discount-img.88dda139.png";